import React from 'react'

function Developed() {

    return (
        <span className='custom-font'>
            Web Design & Development by <a href="https://webexpressions.net/" title='Web Expressions, Professional web design agency, custom web design services' target="_blank" rel="noreferrer" >Web Expressions, Inc</a>
        </span>
    )
}

export default Developed